import { useMemo } from "react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { googleAPIKey } from "../../firebase-config/google";
import { Box } from "@mui/material";

const MapComponent = ({ marks, onClick, height, showTopGradiant }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleAPIKey,
  });

  if (!isLoaded) return <div>Loading...</div>;
  return (
    <Map
      marks={marks}
      onClick={onClick}
      height={height}
      showTopGradiant={showTopGradiant}
    />
  );
};

function Map({ marks, onClick = () => {}, height = "90vh", showTopGradiant }) {
  function findBoundingBox() {
    const markers = marks;
    let minLat = markers.reduce(
      (min, marker) => Math.min(min, marker?.lat),
      markers[0]?.lat
    );
    let maxLat = markers.reduce(
      (max, marker) => Math.max(max, marker?.lat),
      markers[0]?.lat
    );
    let minLng = markers.reduce(
      (min, marker) => Math.min(min, marker?.lng),
      markers[0]?.lng
    );
    let maxLng = markers.reduce(
      (max, marker) => Math.max(max, marker?.lng),
      markers[0]?.lng
    );

    return {
      lat: maxLat,
      lng: maxLng,
    };
  }

  const center = useMemo(() => findBoundingBox(), [marks]);
  console.log(marks);

  return (
    <GoogleMap
      zoom={5}
      center={center}
      mapContainerStyle={{ width: "100%", height: height }}
      onClick={onClick}
    >
      {marks.map((m, i) => (
        <MarkerF
          key={i}
          position={m}
          icon={{
            url: "/assets/img/icons/location_map.svg",
          }}
        >
          {/* <InfoWindow
          // onCloseClick={() => {
          //   setIsOpen(false);
          // }}
          >
            <h3>"Test"</h3>
          </InfoWindow> */}
        </MarkerF>
      ))}

      {showTopGradiant && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            width: "100%",
            height: "40px",
            background:
              "linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 60%)",
          }}
        />
      )}
    </GoogleMap>
  );
}
export default MapComponent;
